// extracted by mini-css-extract-plugin
export var buttonContainer = "_7u-1";
export var fontSizeSelect = "_7u-3";
export var formatSelect = "_7u-2";
export var formats = "_7u-4";
export var hidden = "_7u-5";
export var icon = "_7u-6";
export var select = "_7u-0";